import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAgreementByNumber } from './../app-context/policyProduction'
import { RootState } from '../app-context/store';

interface AgreementCheckboxesProps {
  agreementAlert: boolean;
  productionData: any;
  setAgreements: (name: string) => void;
}

const styleObj = {
  width: '20px',
margin: '5px',
padding: '0px',
height: '20px'
};


const AgreementCheckboxes: React.FC<AgreementCheckboxesProps> = ({ agreementAlert, productionData, setAgreements }) => {

  const dispatch = useDispatch();
  const agreementData = useSelector((state: RootState) => state.policyProduction.agreementCheckboxesData)
  console.log('agreementData', agreementData)

  // const [agreements, setAgreements] = useState({
  //   termsOfService: false,
  //   privacyPolicy: false,
  //   marketingEmails: false,
  // });


  // useEffect(() => {
  //   dispatch(setAgreementByNumber(agreements))

  // }, [agreements])


  // const handleCheckboxChange = (name: string) => {
  //   setAgreements((prev) => {
  //     const updatedAgreements = {
  //       ...prev,
  //       [name]: !prev[name as keyof typeof prev],
  //     };

  //     //   onAgreeAll(Object.values(updatedAgreements).every(Boolean));

  //     return updatedAgreements;
  //   });
  //   console.log('agreements', agreements)

  // };

  return (
    <div className='agreement-checkboxes-wapper' style={{ direction: 'rtl', padding: 10}}>
      <label style={{ border: agreementAlert ? '1px solid red' : 'none' ,display: 'flex',alignItems: 'center',fontSize: '17px'}} >
        <input
          style={styleObj}
          type="checkbox"
          checked={productionData.checkbox1}
          onChange={() => setAgreements('checkbox1')}
        />
        ביררתי את צורכי המועמד לביטוח לפני הפקת פוליסת הביטוח(בהתאם לחוזר המפקח בדבר צירוף לביטוח)
      </label>
      <label style={{ border: agreementAlert ? '1px solid red' : 'none' ,display: 'flex',alignItems: 'center',fontSize: '17px'}}>
        <input
          style={styleObj}
          type="checkbox"
          checked={productionData.checkbox2}
          onChange={() => setAgreements('checkbox2')}
        />
        המועמד לביטוח אישר להפיק את הפוליסה
      </label>
      <label style={{ border: agreementAlert ? '1px solid red' : 'none' ,display: 'flex',alignItems: 'center',fontSize: '17px'}}>
        <input
          style={styleObj}
          type="checkbox"
          checked={productionData.checkbox3}
          onChange={() => setAgreements('checkbox3')}
        />
        עדכנתי את המבוטח שברכישת פוליסת ביטוח, החברה פונה למאגרי מידע שעיקרם אימות נתוני רכב, בעלות, רישום והיסטוריית תאונות לצורך אימות נתונים
      </label>
    </div>
  );
};

export default AgreementCheckboxes;
